import { useApiMonOrga } from '~/composables/api/useApiMonOrga'
import { normalizeUserPreferencesPayload } from '~/utils/userPreferences/normalizeUserPreferences'
import type { UserPreferencesPayload } from '~/utils/userPreferences/types'

export async function fetchPrefsFromApi(): Promise<UserPreferencesPayload | null> {
  try {
    const response = await useApiMonOrga<{ preferences: UserPreferencesPayload | null }>(
      'GET',
      '/v1/me/preferences',
    )
    const prefs = response?.preferences ?? null
    if (prefs === null) {
      return null
    }
    return normalizeUserPreferencesPayload(prefs)
  } catch {
    return null
  }
}

export async function putUserPreferencesToApi(prefs: UserPreferencesPayload): Promise<void> {
  await useApiMonOrga('PUT', '/v1/me/preferences', undefined, { preferences: prefs })
}

export async function savePrefsToApi(prefs: UserPreferencesPayload): Promise<void> {
  try {
    await putUserPreferencesToApi(prefs)
  } catch (error) {
    console.warn('[useUserPreferences] Échec de la synchronisation des préférences avec le serveur.', error)
  }
}
